import { render, staticRenderFns } from "./ConfigurationForm172.vue?vue&type=template&id=450b1bd9&scoped=true&lang=pug&"
import script from "./ConfigurationForm172.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm172.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm172.vue?vue&type=style&index=0&id=450b1bd9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450b1bd9",
  null
  
)

export default component.exports